import { formatISO, startOfMinute } from "date-fns";

import type { EmployeeGoalsFilter } from "../../../Goals/Employee/Filters";

const formatDateType = (date: Date): string => {
	return formatISO(startOfMinute(date));
};

export const getMeetingGoalsSearchFilters = (
	filters: Partial<EmployeeGoalsFilter>,
	searchValue: string,
	allowedAssigneeIds: string[],
	currentUserId: string
): Record<string, unknown> => {
	const finalFilters: Record<string, unknown> = {};
	const visibleAssigneeIds = allowedAssigneeIds.filter(Boolean);

	if (currentUserId) {
		finalFilters["user_being_viewed"] = currentUserId;
	}

	if (visibleAssigneeIds.length > 0) {
		finalFilters["assignee_or_sharers_in"] = visibleAssigneeIds;
	}

	if (filters.assignee && filters.assignee.length > 0) {
		const selectedAssignees = filters.assignee.map((assignee) => assignee.id);
		const filteredAssignees =
			visibleAssigneeIds.length > 0
				? selectedAssignees.filter((assigneeId) => visibleAssigneeIds.includes(assigneeId))
				: selectedAssignees;

		if (filteredAssignees.length > 0) {
			finalFilters["assignee_in"] = filteredAssignees;
		}
	}

	if (filters.createdDateAfter) {
		finalFilters["created_gt"] = formatDateType(filters.createdDateAfter);
	}

	if (filters.createdDateBefore) {
		finalFilters["created_lt"] = formatDateType(filters.createdDateBefore);
	}

	if (filters.dueDateAfter) {
		finalFilters["end_date_gt"] = formatDateType(filters.dueDateAfter);
	}

	if (filters.dueDateBefore) {
		finalFilters["end_date_lt"] = formatDateType(filters.dueDateBefore);
	}

	if (filters.category && filters.category.length > 0) {
		finalFilters["categories_in"] = filters.category.map((category) => category.id);
	}

	if (filters.status) {
		finalFilters["status_in"] = filters.status;
	}

	if (filters.transparency) {
		finalFilters["transparency_in"] = filters.transparency;
	}

	if (filters.outlook && filters.outlook.length > 0) {
		finalFilters["color_in"] = filters.outlook.map((outlook) => outlook.id);
	}

	if (filters.showSharedOnly && filters.showSharedOnly.length > 0) {
		finalFilters["is_shared_eq"] = true;
	}

	if (filters.unseenUpdatesOnly && filters.unseenUpdatesOnly.length > 0) {
		finalFilters["has_updates_eq"] = true;
	}

	if (filters.alignedTo) {
		finalFilters["ancestors_in"] = [filters.alignedTo.id];
	}

	if (searchValue) {
		finalFilters["name_re"] = searchValue;
	}

	return finalFilters;
};
